import $ from 'jquery';

export function initCarouselMultiple(panelName) {
  panelName.each(function (indexP, itemP) {
    $(itemP).find('.carousel-item').each(function (index, item) {

      var next = $(item).next();
      if (!next.length) {
        next = $(item).siblings(':first');
      }
      next.children(':first-child').clone().appendTo($(item));

      for (var i = 0; i < 4; i++) {
        next = next.next();
        if (!next.length) {
          next = $(item).siblings(':first');
        }
        next.children(':first-child').clone().appendTo($(item));
      }
    });
    $(itemP).show(function () {
      $(itemP).carousel({
        interval: 2500,
        cycle: true
      });
    })
  });
}